import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import TcService from './TcService';

// Actions
const GET_TC_CYCLE = 'tc/GET_TC_CYCLE';
const GET_TC_CYCLE_EVENTS = 'tc/GET_TC_CYCLE_EVENTS';
const GET_TC_CYCLE_FILTERED_EVENTS = 'tc/GET_TC_CYCLE_FILTERED_EVENTS';
const CLEAR_TC = 'tc/CLEAR_TC';
const GET_TC_CYCLES = 'tc/GET_TC_CYCLES';
const GET_TC = 'tc/GET_TC';

const initialState = {
  testCenter: {},
  tcCycle: {},
  tcCycles: {},
};

// Reducer
export default function tcReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TC:
      return {
        ...state,
        testCenter: action.result.data || {},
        loading: action.result.loading,
      };
    case GET_TC_CYCLE:
      return {
        ...state,
        tcCycle: {
          ...state.tcCycle,
          ...action.result.data,
        },
      };
    case GET_TC_CYCLES:
      return {
        ...state,
        tcCycles: {
          ...state.tcCycles,
          ...action.result.data,
          loading: action.result.loading,
        },
      };
    case GET_TC_CYCLE_EVENTS:
      return {
        ...state,
        tcCycle: {
          ...state.tcCycle,
          events: action.result.data || [],
        },
      };
    case GET_TC_CYCLE_FILTERED_EVENTS:
      return {
        ...state,
        tcCycle: {
          ...state.tcCycle,
          filteredEvents: action.result.data || [],
          loading: action.result.loading,
        },
      };
    case CLEAR_TC:
      return {
        ...state,
        testCenter: initialState.testCenter,
      };
    default:
      return state;
  }
}

// Action Creators
export function getTCAction(result) {
  return { type: GET_TC, result };
}

export function clearTCAction() {
  return { type: CLEAR_TC };
}

export function getTcCycleAction(result) {
  return { type: GET_TC_CYCLE, result };
}

export function getTcCycleEventsAction(result) {
  return { type: GET_TC_CYCLE_EVENTS, result };
}

export function getTcCycleFilteredEventsAction(result) {
  return { type: GET_TC_CYCLE_FILTERED_EVENTS, result };
}

export function getTCCyclesAction(result) {
  return { type: GET_TC_CYCLES, result };
}

// Action dispatcher functions

export function getTC(tcId) {
  return createDispatchFunction(
    partial(TcService.getTC, tcId),
    getTCAction
  );
}

export function getTcCycle(tcCycleId) {
  return createDispatchFunction(
    partial(TcService.getTcCycle, tcCycleId),
    getTcCycleAction
  );
}

export function getTcCycleEvents(tcCycleId) {
  return createDispatchFunction(
    partial(TcService.getTcCycleEvents, tcCycleId),
    getTcCycleEventsAction
  );
}

export function getTcCycleFilteredEvents(tcCycleId) {
  return createDispatchFunction(
    partial(TcService.getTcCycleFilteredEvents, tcCycleId),
    getTcCycleFilteredEventsAction
  );
}

export function getTCCycles(tcId, status) {
  return createDispatchFunction(
    partial(TcService.getTCCycles, tcId, status),
    getTCCyclesAction
  );
}